import Section from "../../common/section";
import Image from "next/image";
import FormImg from "public/images/contact/Picture-Contact-Form.png";
import { getTitleClass, getThemeClass, getBodyClass } from "~/styles/styles";
import ContactForm from "./contactForm";
import { forwardRef, type LegacyRef } from "react";

type ContactFormProps = {
  formRight?: boolean;
};

const ContactFormSection = (
  { formRight }: ContactFormProps,
  ref: LegacyRef<HTMLElement> | undefined,
) => {
  return (
    <Section id="form" ref={ref} className={`flex ${getThemeClass("dark")}`}>
      <div className="flex w-full">
        <div
          className={`TEXTs container m-auto w-full max-w-[30rem] px-8 py-12 xs:px-12 md:max-w-[45rem] ml:w-1/2 ${
            formRight ? "lg:ml-8" : "lg:mr-8"
          } xl:p-16`}
        >
          <div className="mb-1 md:mb-3">
            <h2
              className={`mb-1 font-bold text-green lg:mb-2 ${getTitleClass("base")}`}
            >
              How can we help?
            </h2>
            <p className={`text-sm lg:text-base`}>
              We are a passionate team and want to do anything we can to help.{" "}
              <span className="xl:block">
                Let us know how we can help you by filling out the form below.
              </span>
            </p>
          </div>

          <ContactForm />
        </div>

        <div
          className={`md:max-h-[50rem] md:w-1/2 ${formRight ? "order-first" : ""}`}
        >
          <Image
            src={FormImg}
            alt="img"
            className="hidden h-full w-full object-cover md:block"
          />
        </div>
      </div>
    </Section>
  );
};

export default forwardRef(ContactFormSection);
